export default {
	namespaced: true,
	state: {
		items: []
	},

	actions: {
		addItem(context, payload)
		{
			
			if(payload.type === 'route')
			{
				
				context.commit('addRouteItem', payload)
			} else {
				let route = context.rootGetters['routes/route'];
				payload.route = route;
				context.commit('addLocationItem', payload)
			}
			
			//context.commit('addItem', payload)
		},

		flushItems(context)
		{
			context.commit('flushItems');
		}
	},

	mutations: {

		addRouteItem(state, payload)
		{
			let items = [];

			items.push({text:payload.text});

			state.items = items;
			
		},

		addLocationItem(state, payload)
		{
			
			let items = [];
			state.items = [];
			if(typeof payload.route !== 'undefined')
			{
				items.push({text:payload.route.displayName});
			} else {
				console.error("breadcrumbs/addLocationItem::", "route is undefined");
			}
			items.push({text:payload.text});


			

			state.items = items;
			
			

		},

		

		flushItems(state)
		{
			state.items = []
		}
	},



	getters: {
		items(state)
		{
			return state.items;
		}
	}
}